<!-- Produce a row with a side by side label and form controls -->
<template>
    <div class="row q-col-gutter-x-md">
        <div class="form-label" :class="stacked ? 'col-12' : 'col-4 text-right'">
            <label :class="{'text-capitalize': capitalize}">
                <slot name="label">
                    {{ label }}
                </slot>
            </label>
            <span v-if="required" class="required-indicator">*</span>
            <slot name="after-label" />
            <small v-if="tooltip" class="block">{{ tooltip }}</small>
        </div>
        <div :class="stacked ? 'col-12': 'col-8'">
            <slot />
        </div>
    </div>
</template>

<script setup>
defineProps({
    label: String,
    tooltip: String,
    required: Boolean, // Adds a required indicator (*)
    stacked: Boolean, // Stack label vertically rather than side-by-side with input
    capitalize: Boolean,
})
</script>

<style>
.form-label { margin-top: 10px }
</style>
